import React, { useRef, useEffect } from "react";
import { allAcceptedUploadTypes } from "../useFileUpload";
import styles from "./UploadPopup.module.css";
import { FileDropZone } from "../../../components/files/FileDropZone/FileDropZone";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onFilesAdded: (files: File[]) => void;
  buttonRef: React.RefObject<HTMLButtonElement>;
}

const UploadPopup: React.FC<Props> = ({
  isOpen,
  onClose,
  onFilesAdded,
  buttonRef,
}) => {
  const popupRef = useRef<HTMLDivElement>(null);

  // Click-outside close
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(e.target as Node) &&
        buttonRef.current &&
        !buttonRef.current.contains(e.target as Node)
      ) {
        onClose();
      }
    };
    if (isOpen) document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, onClose, buttonRef]);

  if (!isOpen) return null;

  return (
    <div className={styles.popup} ref={popupRef}>
      <FileDropZone
        onFilesAdded={(files) => {
          onFilesAdded(files);
          onClose(); // close popup after files are picked
        }}
        accept={allAcceptedUploadTypes.join(",")}
        label="Click or drop files<br/><span style='font-size:0.65rem; color:#9a9a94; font-weight:400'>PDF, Office, Images</span>"
      />
    </div>
  );
};

export default UploadPopup;